"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHANGE_EXAMPLE = 'jsonforms-example/CHANGE';
exports.changeExample = function (example) { return ({
    type: exports.CHANGE_EXAMPLE,
    example: example
}); };
//# sourceMappingURL=example.js.map